import { render, staticRenderFns } from "./EditUsers.vue?vue&type=template&id=97e7d416&scoped=true&"
import script from "./EditUsers.vue?vue&type=script&lang=js&"
export * from "./EditUsers.vue?vue&type=script&lang=js&"
import style0 from "./EditUsers.vue?vue&type=style&index=0&id=97e7d416&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e7d416",
  null
  
)

export default component.exports